import React from "react";
import HomeScorecardCard from "./homeScorecardCard";
import { ScorecardQA } from "./cardScorecardQAData";
import PopUpFormScorecardDownloadScorecard from "../../../../popUpForms/popUpScorecardFormDownloadScorecard";

const icons = [
  {
    title: "Windows",
    aria: "Download button for zip file extraction tool for windows operating system",
    icon: "fa-windows",
  },
  {
    title: "Mac",
    aria: "Download button for zip file extraction tool for Mac operating system",
    icon: "fa-apple",
  },
  {
    title: "Linux",
    aria: "Download button for zip file extraction tool for Linux operating system",
    icon: "fa-linux",
  },
];

const CardScorecardOverviewScorecard = ({
  hoveredTab,
  onTabHover,
  onTabLeave,
}) => {
  return (
    <HomeScorecardCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="scorecard-download"
      title="Scorecard Overview "
      titleColor="var(--cornflower-blue)"
      image="./images/home/card-scorecard-details.png"
      popUpComponent={<PopUpFormScorecardDownloadScorecard />}
      content={[
        { type: "dropdown", data: ScorecardQA },
        {
          type: "button",
          text: "Download Scorecard",
          color: "var(--cornflower-blue)",
        },
        {
          type: "bottom-paragraph",
          text: "Need a zip file extraction tool?",
          color: "var(--white)",
        },
        { type: "icons", icons: icons },
        {
          type: "bottom-paragraph",
          text: "Problems Downloading? <a href='#support'>Contact Us</a>",
          color: "var(--white)",
        },
      ]}
    />
  );
};

export default CardScorecardOverviewScorecard;
